import { useRef, useEffect } from 'react';

export default function useScrollReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const handleReveal = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          node.classList.add('opacity-100', 'translate-y-0');
          node.classList.remove('opacity-0', 'translate-y-8');
        }
      });
    };
    const observer = new window.IntersectionObserver(handleReveal, {
      threshold: 0.2
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return ref;
} 